import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Button,
  Typography,
  Autocomplete,
} from "@mui/material";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";

// Function Starts
const AddJobModal = ({
  open,
  handleClose,
  source,
  formOptions,
  submitButton,
}) => {
  const [formData, setFormData] = useState({});

  const handleFormChange = (event) => {
    const { value, name } = event.target;

    setFormData((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();

    submitButton("ABCD12345", formData);
    handleClose();
  };

  //For Different types of Inputs in the Form
  const resolveFormField = (formField, index) => {
    switch (formField.type) {
      case "Date":
        return (
          <>
            <Row md="2" className="align-items-center">
              <Col>
                <Typography>{formField.name}</Typography>
              </Col>
              <Col>
                <TextField
                  name={formField.name}
                  style={{ width: "100%" }}
                  label={formField.name}
                  placeholder="YYYY-mm-ddTHH:MM"
                  type="datetime-local"
                  onChange={handleFormChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Col>
            </Row>
          </>
        );

      case "Options":
        return (
          <>
            <Row md="2" className="align-items-center">
              <Col>
                <Typography>{formField.name}</Typography>
              </Col>
              <Col>
                <Autocomplete
                  style={{ width: "100%" }}
                  options={formOptions[formField.name]}
                  getOptionLabel={(option) => option}
                  renderInput={(params) => (
                    <TextField {...params} label={formField.name} />
                  )}
                  onChange={(event, newValue) => {
                    setFormData((prevValue) => ({
                      ...prevValue,
                      [formField.name]: newValue,
                    }));
                  }}
                />
              </Col>
            </Row>
          </>
        );

      default:
        return (
          <>
            <Row md="2" className="align-items-center">
              <Col>
                <Typography>{formField.name}</Typography>
              </Col>
              <Col>
                <TextField
                  name={formField.name}
                  style={{ width: "100%" }}
                  label={formField.name}
                  onChange={handleFormChange}
                />
              </Col>
            </Row>
          </>
        );
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">Create Job</DialogTitle>
        <DialogContent>
          <DialogContentText>Some Title</DialogContentText>
          {source.formFields.map((value, index) => {
            return resolveFormField(value, index);
          })}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleFormSubmit} color="primary">
            Submit Job
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddJobModal;
